import axios from "axios"
import { apiWrapperEndpoint } from "../configs/Settings"
const apiCaller = axios.create({
	baseURL: apiWrapperEndpoint,
	headers: {
		"x-issuer": "PORTAL",
	},
})
apiCaller.interceptors.response.use((res) => {
	res.data.payload = res.data.data
	return res
})
class Customer {
	async getOTP(payload, config) {
		const { mobileNo } = payload
		const res = await apiCaller.post(
			"ms-customer/api/Member/web/SendOTPSMS",
			{ mobileNo: mobileNo },
			config
		)
		return res
	}
	async validateOTP(payload, config) {
		const { mobileNo, otpCode } = payload
		const res = await apiCaller.post(
			"ms-customer/api/Member/web/ValidateOTP",
			{ mobileNo: mobileNo, otpCode: otpCode },
			config
		)
		return res
	}
	async resetPasswordByMobile(payload, config) {
		const { token, password, comfirmPassword } = payload
		const res = await apiCaller.post(
			"ms-customer/api/Member/ResetPassword",
			{
				password: password,
				confirmPassword: comfirmPassword,
			},
			{
				...config,
				headers: { ...config.headers, Authorization: `Bearer ${token}` },
			}
		)
		return res
	}
	async login(payload, config) {
		const { username, password, keepLogin } = payload
		const res = await apiCaller.post(
			"ms-customer/api/Member/SignIn",
			{ username: username, password: password, keepLogin: keepLogin },
			config
		)
		return res
	}
	async createAccount(payload, config) {
		const res = await apiCaller.post(
			"ms-customer/api/Member/web/SignUp",
			this.mappingPayloadCreateAccount(payload),
			config
		)
		return res
	}

	async getAllStore(config) {
		const res = await apiCaller.get("ms-monp/api/store/search", config)
		return res
	}

	mappingPayloadCreateAccount(payload) {
		const {
			mobileNo,
			email,
			password,
			confirmPassword,
			registerType,
			firstName,
			lastName,
			dob,
			nationality,
			salutation,
			cardNo,
			securityCode,
			device,
		} = payload
		return {
			mobileNo: mobileNo,
			email: email,
			password: password,
			confirmPassword: confirmPassword,
			registerType: registerType,
			firstName: firstName,
			lastName: lastName,
			dob: dob,
			nationality: nationality || "KH",
			salutation: salutation,
			subscription: { email: true },
			cardLists: [{ cardNo: cardNo, passcode: securityCode }] || [
				{ cardNo: "", passcode: "" },
			],
			gender: "",
			device,
		}
	}
}

export const customerService = new Customer()



// WEBPACK FOOTER //
// ./src/service/customerService.js